import {
  DELETE_CUSTOM_FIELDS,
  SET_CUSTOM_FIELDS,
  ADD_CUSTOM_FIELDS,
  SET_TEMPID,
  SET_WHATS_USING,
} from "./actionTypes";

export const deleteCustomField = (deletedCustomField) => ({
  type: DELETE_CUSTOM_FIELDS,
  deletedCustomField: deletedCustomField,
});
export const whatsUsingThem = (whatsUsingThem) => ({
  type: SET_WHATS_USING,
  whatsUsingThem: whatsUsingThem
})
export const setCustomFields = (currentCustomFields) => ({
  type: SET_CUSTOM_FIELDS,
  currentCustomFields: currentCustomFields,
});

export const addCustomFields = (customFields) => ({
  type: ADD_CUSTOM_FIELDS,
  customFields: customFields,
});

export const setTempId = (tempId) => ({
  type: SET_TEMPID,
  tempId: tempId,
});
